const EarlyRome = {
  id: '5',
  name: 'Early Rome'
};

export default EarlyRome;
